import { render, staticRenderFns } from "./Locals.vue?vue&type=template&id=15f04d3a&scoped=true"
import script from "./Locals.vue?vue&type=script&lang=js"
export * from "./Locals.vue?vue&type=script&lang=js"
import style0 from "./Locals.vue?vue&type=style&index=0&id=15f04d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f04d3a",
  null
  
)

export default component.exports